export default {
  state: {
    vaccineData: {},
  },

  getters: {
    getVaccineData(state) {
      return state.vaccineData;
    },
  },

  mutations: {
    setVaccineData(state, data) {
      const isNull = data === null;

      state.vaccineData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
        batch: !isNull ? data.batch : "",
      };
    },
  },

  actions: {
    changeVaccineData(context, infos) {
      context.commit("setVaccineData", infos);
    },
  },
};
